import styled from 'styled-components';
import { cn } from '@shadcn/lib/utils';
import { BOTTOM_NAVBAR_HEIGHT_VARIABLE } from 'components/navbars/BottomNavbar';

export const AMBOSS_CONTENT_BOTTOM = `var(${BOTTOM_NAVBAR_HEIGHT_VARIABLE}, 0px)`;

const CARD_SURFACE =
  'fixed inset-x-4 z-50 overflow-hidden rounded-xl bg-card shadow-[0_1px_3px_rgba(0,0,0,0.08),0_8px_24px_rgba(0,0,0,0.18)]';

export const AmbossScrim = styled.div.attrs({
  className: 'fixed inset-0 z-50 bg-scrim animate-in fade-in duration-200 ease-out',
})``;

export const AmbossCard = styled.div.attrs({
  className: cn(CARD_SURFACE, 'flex flex-col'),
})``;

export const AmbossSearchCard = styled.div.attrs({
  className: cn(CARD_SURFACE, 'animate-in fade-in slide-in-from-top-2 duration-200 ease-out'),
})``;

export const AmbossCardBody = styled.div.attrs({
  className: 'relative min-h-0 flex-1',
})``;

export const AmbossEmbedFrame = styled.div.attrs({
  className: 'absolute inset-0 bg-background',
})``;

export const AmbossHistoryOverlay = styled.div.attrs({
  className: 'absolute inset-0 animate-in fade-in duration-200 ease-out bg-card',
})``;

export const AmbossHelpPanel = styled.div.attrs({
  className:
    'absolute inset-x-0 top-0 animate-in fade-in slide-in-from-top-2 duration-200 ease-out',
})``;

export const AmbossPanel = styled.div.attrs({
  className: 'w-full bg-card p-4',
})``;

export const AmbossHeaderBar = styled.div.attrs({
  className:
    'flex h-12 shrink-0 items-center gap-2 bg-card px-3 py-2 shadow-[0_1px_0_0_rgba(0,0,0,0.05)]',
})``;

export const AmbossActionBar = styled.div.attrs<{ $spacious?: boolean }>((props) => ({
  className: cn(
    'flex shrink-0 items-center text-vantis-violet',
    props.$spacious ? 'gap-3' : 'gap-2'
  ),
}))<{ $spacious?: boolean }>``;

export const AmbossIconButton = styled.button.attrs<{ $active?: boolean; $compact?: boolean }>(
  (props) => ({
    type: 'button',
    className: cn(
      'flex shrink-0 cursor-pointer items-center justify-center rounded-md hover:bg-muted',
      props.$compact ? 'size-6' : 'size-8',
      props.$active && 'bg-muted'
    ),
  })
)<{ $active?: boolean; $compact?: boolean }>``;

export const AmbossHeaderTitle = styled.p.attrs({
  className: 'min-w-0 flex-1 truncate text-sm font-semibold leading-5 text-foreground',
})``;
